import React, { useCallback, useReducer, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Divider,
    Typography,
} from '@mui/material';
import { ValidDataService } from '../../../../service/validDataService';
import { isLocalDev } from '../../../../utils/environment';
import useAbortController from '../../../../hooks/useAbortController';
import EnhancedTable from '../../../enhancedTable/EnhancedTable';
import { validLabsColumns } from './columns';

export default function LabSelectDialog({ open, onClose, onSelect }) {
    const [signal, abortRequest] = useAbortController();
    const [selection, setSelection] = useState();
    const [state, updateState] = useReducer((state, params) => {
        return { ...state, ...params };
    }, {
        data: [],
        totalRowCount: 0,
        pageCount: 0,
        loading: false,
    });

    const fetchData = useCallback(({ pageSize, pageIndex, filters, sortBy }) => {
        const from = pageSize * pageIndex;
        updateState({ loading: true });
        ValidDataService.getValidLabDataWithLimit(from, pageSize, filters, sortBy, signal).then(result => {
            const { code, data } = result;
            if (code === 0) {
                updateState({
                    data: data.data,
                    totalRowCount: data.count,
                    pageCount: Math.ceil(data.count / pageSize),
                });
            }
            updateState({ loading: false });
        }).catch(error => {
            if (isLocalDev) {
                console.error(error)
            }
            updateState({ loading: false });
        });
    }, [signal]);

    const handleSelect = () => {
        if (selection && selection[0] && onSelect) {
            onSelect(selection[0]);
            onClose();
        }
    };

    const handleClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return;
        }
        abortRequest();
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
            <DialogTitle>Select Lab</DialogTitle>
            <DialogContent>
                <Box>
                    <Typography variant="h4">Labs</Typography>
                    <Divider sx={{ mb: 2 }} />
                    <EnhancedTable
                        columns={validLabsColumns}
                        data={state.data}
                        totalRowCount={state.totalRowCount}
                        pageCount={state.pageCount}
                        fetchData={fetchData}
                        loading={state.loading}
                        selectionMode="single"
                        onRowSelected={(row) => setSelection(row)}
                        actions={[]}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSelect} variant='contained' disabled={!selection}>
                    Select
                </Button>
                <Button onClick={onClose} color="cancel" variant='outlined'>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}